import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { putApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { MaintenanceCostTypesForm } from '../../forms/maintenanceCostTypes/MaintenanceCostTypesForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { MaintenanceCostType, MaintenanceCostTypeInputs } from '../../types/maintenanceCost.types';
import { DetailPageParams } from '../../types/pageParams.types';
import { API_URL, fetcher } from '../../utils/apiUrl';

export function MaintenanceCostTypesEdit() {
  const { translate } = useTranslation();
  const transFormName = 'MaintenanceCostType.Update';
  const { startLoading, stopLoading } = useLoading();
  const { id } = useParams<DetailPageParams>();
  const { data, error } = useSWR<MaintenanceCostType>(
    `${API_URL.MAINTENANCE_COST_TYPE_ITEM}?id=${id}`,
    fetcher,
  );
  const [formData, setFormData] = useState<MaintenanceCostTypeInputs>();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Edit maintenance cost type',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Maintenance cost types', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  useEffect(() => {
    if (!data) return;
    setFormData({ ...data });
  }, [data]);

  const onSubmit = async (e) => {
    if (e !== null) e.preventDefault();
    if (!data) return;

    let isOk = false;
    startLoading();
    await putApi({
      url: API_URL.MAINTENANCE_COST_TYPE_PUT,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper
      heading={translate!('Edit maintenance cost type', transFormName)}
      error={error}
    >
      <MaintenanceCostTypesForm onSubmit={onSubmit} formData={formData} isEdit />
    </PageContentWrapper>
  );
}

export default MaintenanceCostTypesEdit;
